/* eslint-disable */
import { ORDERS_FIND_BY_STATUS, ORDERS_FIND_BY_STATUS_COMPLETE, ORDERS_FIND_BY_STATUS_ERROR, ORDERS_FIND_BY_STATUS_SUCCESS } from '../Orders.types';

/**
 * Fetch a specific `order` by its `status`
 * @param {OrderServiceFindByStatusDto} dto The required params to find an order by its `status`
 * @returns {ActionCreator<FromPromise>} The created `Action`
 */
const ordersFindByStatus = ({ orderCode, orderLine, status, billToAccount }) => ({ orderService, fromPromise, getState }) => {
  const state = getState();
  const promise = orderService.findByStatus({ orderCode, orderLine, state, status, billToAccount });
  return fromPromise(promise, { params: { orderCode, orderLine, status } }, [
    ORDERS_FIND_BY_STATUS,
    ORDERS_FIND_BY_STATUS_COMPLETE,
    ORDERS_FIND_BY_STATUS_ERROR,
    ORDERS_FIND_BY_STATUS_SUCCESS,
  ]);
};

export default ordersFindByStatus;

export const createInjectedActionOrdersFindByStatus = ordersFindByStatus
